import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { deleteProduct, fetchAdminProducts } from "../../api/admin";
import { euro, imageUrl } from "../../api/shop";

export default function AdminProducts() {
  const { token } = useAuth();
  const [data, setData] = useState({ items: [], total: 0, pages: 1, page: 1 });
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = () => {
    setLoading(true);
    fetchAdminProducts({ page, q }, token)
      .then(setData)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(load, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  const search = (e) => {
    e.preventDefault();
    setPage(1);
    load();
  };

  const remove = async (product) => {
    if (!window.confirm(`¿Eliminar "${product.brand} ${product.title}"? Esto no se puede deshacer.`)) return;
    try {
      await deleteProduct(product._id, token);
      setData((d) => ({ ...d, items: d.items.filter((p) => p._id !== product._id) }));
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <>
      <div className="admin__head">
        <div>
          <p className="eyebrow">Catálogo</p>
          <h1 style={{ fontSize: "1.9rem" }}>Productos</h1>
        </div>
        <Link to="/admin/productos/nuevo" className="btn btn--lg">
          + Añadir móvil
        </Link>
      </div>

      <form className="admintoolbar" onSubmit={search}>
        <input
          type="search"
          placeholder="Buscar por marca, modelo o SKU…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <button type="submit" className="btn btn--ghost">
          Buscar
        </button>
      </form>

      {error && <div className="alert alert--error">{error}</div>}

      {loading ? (
        <div className="hero__skeleton" style={{ height: 300 }} />
      ) : data.items.length === 0 ? (
        <div className="state">
          <h3>Todavía no hay productos</h3>
          <p>Añade tu primer móvil para que aparezca en la tienda.</p>
          <Link to="/admin/productos/nuevo" className="btn btn--lg">
            + Añadir móvil
          </Link>
        </div>
      ) : (
        <div className="admintable">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Producto</th>
                <th>SKU</th>
                <th>Precio</th>
                <th>Stock</th>
                <th>Estado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((p) => (
                <tr key={p._id}>
                  <td>
                    <img className="admintable__thumb" src={imageUrl(p.images?.[0])} alt="" />
                  </td>
                  <td>
                    <div style={{ fontWeight: 600 }}>{p.brand} {p.title}</div>
                    <div className="eyebrow">{p.category}</div>
                  </td>
                  <td className="mono">{p.sku}</td>
                  <td className="mono">
                    {p.discountPrice && p.discountPrice < p.price ? (
                      <>
                        <span style={{ textDecoration: "line-through", color: "var(--stone)" }}>{euro(p.price)}</span>{" "}
                        {euro(p.discountPrice)} €
                      </>
                    ) : (
                      `${euro(p.price)} €`
                    )}
                  </td>
                  <td className="mono">{p.stock}</td>
                  <td>
                    <span className={`pill ${p.isActive ? "pill--confirmed" : "pill--cancelled"}`}>
                      {p.isActive ? "Publicado" : "Oculto"}
                    </span>
                  </td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <Link to={`/admin/productos/${p._id}`} className="linkish" style={{ marginRight: 14 }}>
                      Editar
                    </Link>
                    <button className="linkish" style={{ color: "var(--danger)" }} onClick={() => remove(p)}>
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {data.pages > 1 && (
        <nav className="pager" aria-label="Paginación">
          <button className="btn btn--ghost" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>
            Anterior
          </button>
          <span>
            {data.page} / {data.pages}
          </span>
          <button className="btn btn--ghost" disabled={page >= data.pages} onClick={() => setPage((p) => p + 1)}>
            Siguiente
          </button>
        </nav>
      )}
    </>
  );
}
